<template>

    <!--
        B2.1B - dispatcher reattivo.
        GOD (FK_ID_LIVELLO == 1) resta sul percorso legacy: nessuna modifica.
        La Dashboard Manager e' riservata a FK_ID_LIVELLO == 2 con ruolo
        DASHBOARD_ROLE = MANAGER, replicando la regola di
        DashboardManager::autorizzato() lato backend.
        Il backend resta l'autorita': questa selezione e' solo UX.
    -->
    <div v-if="utenteNonPronto"></div>

    <DashboardManager v-else-if="isManager"></DashboardManager>

    <Dashboard0 v-else-if="livello == 0"></Dashboard0>
    <Dashboard1 v-else-if="livello == 1"></Dashboard1>
    <Dashboard2 v-else-if="livello == 2"></Dashboard2>
    <Dashboard3 v-else-if="livello == 3"></Dashboard3>

</template>



<script>
import Dashboard0 from '@/views/admins/Dashboard0.vue'
import Dashboard1 from '@/views/admins/Dashboard1.vue'
import Dashboard2 from '@/views/admins/Dashboard2.vue'
import Dashboard3 from '@/views/admins/Dashboard3.vue'
import DashboardManager from '@/views/admins/DashboardManager.vue'

const LABEL_RUOLO_DASHBOARD = 'DASHBOARD_ROLE';
const RUOLO_MANAGER = 'MANAGER';


export default {
    name:"Dashboard",
    
    components:{
        Dashboard0,
        Dashboard1,
        Dashboard2,
        Dashboard3,
        DashboardManager,
    },
    
    data:function(){
        return{
            filters:global.filters,
            t:global.t,
            today: new Date(),
            startInterval:{},
            arrayRisultatiRicerca:new Array()
        }
    },

    props: ['todo'],

    computed:{
        /* Reattivo: non piu' la clone di $root.utente fatta una volta sola in created(),
           che non si sincronizzava quando ricaricaPermessi() sostituiva l'oggetto utente. */
        utenteRoot(){
            return this.$root.utente || {};
        },
        livello(){
            return parseInt(this.utenteRoot.FK_ID_LIVELLO, 10) || 0;
        },
        utenteNonPronto(){
            return !(this.utenteRoot.ID_UTENTE > 0);
        },
        /* Ruolo dashboard letto dalle opzioni utente gia' presenti in $root.utente.opzioni.
           Non e' un dato inventato: e' lo stesso array che il backend usa per
           CORE_OPZIONI_UTENTE.LABELS='DASHBOARD_ROLE'.
           Replica la regola di ruoloDashboard(): piu' di un valore non vuoto e distinto
           => ruolo ambiguo => nessuna Dashboard Manager. */
        ruoloDashboard(){
            const opzioni = this.utenteRoot.opzioni;
            if(!Array.isArray(opzioni)) return null;
            const valori = opzioni
                .filter(o => o && o.LABEL === LABEL_RUOLO_DASHBOARD)
                .map(o => String(o.VALORE == null ? '' : o.VALORE).trim())
                .filter(v => v !== '');
            const unici = Array.from(new Set(valori));
            if(unici.length !== 1) return null;
            return unici[0];
        },
        isManager(){
            /* Livello 1 (GOD) non e' mai Manager: conserva la dashboard legacy.
               Livello 2 + ruolo MANAGER = Dashboard Manager. */
            return this.livello === 2 && this.ruoloDashboard === RUOLO_MANAGER;
        }
    },

    methods:{
        varianti : function(){
            this.$root.appoggio.prodotto = {ID_PROGETTO:1};
            this.$root.changeRoute('varianti');
        },
        ricercaResultHandler : function(data){
            this.arrayRisultatiRicerca = new Array();
            this.arrayRisultatiRicerca = data.RISULTATI;
        }
    },

    watch:{
        /* L'utente potrebbe non essere ancora arrivato al created(): si attende. */
        utenteNonPronto : function(ready){
            if(ready === false) this.$root.startUp();
        }
    },

    created: function () {
        /* startUp() resta necessaria: carica i dati di contesto del gestionale.
           Se l'utente non e' ancora arrivato, il watcher la richiama al momento giusto. */
        if(this.utenteNonPronto === false) this.$root.startUp();
    },
}
</script>
